import styled from 'styled-components';
import { Flex } from 'component/base/Grid';

export const Container = styled(Flex)`
  min-height: 100vh;

  @media only screen and (max-width: 1050px) {
    padding-top: 90px;
  }
`;

Container.defaultProps = {
  alignItems: 'center',
  flexDirection: 'column',
  pt: 132,
};
